import React, { useState, ReactElement } from 'react'
import { RadioLine } from '@elamajs/ui-kit'
import { TitleComponent } from '@src/components/UtmGenerator'
import { TableData, TabsData, TitleData } from '@src/data/UtmGenerator'
import { getSvg } from '@src/containers/UtmGenerator/helpers'
import Info from './Info'
import Table from './Table'

import * as Styled from './Tabs.styled'

function Tabs(): ReactElement {
  const [tabsValue, setTabsValue] = useState('direct')

  const onTabsChange = (value: string) => {
    setTabsValue(value)
  }

  return (
    <Styled.Section>
      <div className="container">
        <TitleComponent text="Динамические параметры" />
        <Info />
        <Styled.TabsWrapper>
          <RadioLine options={TabsData} onChange={onTabsChange} value={tabsValue} />
        </Styled.TabsWrapper>
        <Styled.Header>
          <Styled.Title>Параметры для {TitleData[tabsValue]}</Styled.Title>
          <Styled.Link href="https://elama.ru/blog/utm-metki-i-utm-generatory-chto-eto-takoe-i-dlya-chego-oni-nuzhny/">
            Подробнее
            {getSvg('arrow')}
          </Styled.Link>
        </Styled.Header>
        <Table data={TableData[tabsValue]} />
      </div>
    </Styled.Section>
  )
}

export default Tabs
